import React, { useEffect } from "react";

import { IFormUUID, IReviewsProductTypeID } from "../../../models/nominals";
import { useDispatchers } from "../../reducers";
import { WriteReviewFormMode } from "../constants";
import { Dispatchers } from "../dispatchers";
import { WriteReviewButton } from "../elements/WriteReviewButton";
import { WriteReviewForm } from "../elements/WriteReviewForm";
import { WriteReviewThankYou } from "../elements/WriteReviewThankYou";

interface IProps {
    formUUID: IFormUUID;
    brand?: string;
    displayedProductTypeIDWhitelist?: IReviewsProductTypeID[];
}

export const SingleProductCollapsibleWriteReviewForm = (
    props: IProps,
): React.ReactNode => {
    const dispatchers = useDispatchers(Dispatchers);

    useEffect(() => {
        dispatchers.registerNewWriteReviewForm(
            props.formUUID,
            WriteReviewFormMode.CLOSED,
        );
    }, [props.formUUID, dispatchers]);

    const onReviewSubmit = () => {
        const reviewModuleTitle = document.querySelector(
            ".write-review-button__container",
        );
        reviewModuleTitle?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div className="write-review-button__container">
            <WriteReviewButton formUUID={props.formUUID} />
            <WriteReviewForm
                formUUID={props.formUUID}
                formTitle={"Choose your product"}
                brand={props.brand}
                displayedProductTypeIDWhitelist={
                    props.displayedProductTypeIDWhitelist
                }
                onReviewSubmit={onReviewSubmit}
            />
            <WriteReviewThankYou formUUID={props.formUUID} />
        </div>
    );
};
